import type { ReactNode } from 'react'
import { useContext, useEffect, useRef } from 'react'

import { CarouselItemStyled } from './styles/CarouselItemStyled'
import { CarouselContext } from '../../CarouselContext'

export interface ICarouselItemProps {
  children: ReactNode
  /** Injected by the parent `Carousel` — do not set this manually. */
  index?: number
}

export const CarouselItem = ({ children, index }: ICarouselItemProps) => {
  const { activeIndex } = useContext(CarouselContext)
  const ref = useRef<HTMLDivElement>(null)

  const isActive = index === activeIndex

  useEffect(() => {
    if (ref.current) {
      ref.current.inert = !isActive
    }
  }, [isActive])

  return (
    <CarouselItemStyled
      ref={ref}
      role='group'
      aria-roledescription='slide'
      aria-hidden={!isActive}
      $isActive={isActive}
    >
      {children}
    </CarouselItemStyled>
  )
}
